<template>
  <div class="card">
    <div class="header">
      <h4 class="title">{{user.firstName + ' ' + user.lastName}}</h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-3">
            <fg-input class="franchise" type="text" label="Company" :disabled="true" placeholder="user.company" v-model="user.company">
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input type="text" label="First Name" placeholder="First Name" v-model="user.firstName">
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input type="text" label="Last Name" placeholder="Last Name" v-model="user.lastName">
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input type="phone" label="Phone" placeholder="Phone" v-model="user.phone">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <fg-input type="email" label="Username" placeholder="Email" v-model="user.email">
            </fg-input>
          </div>
          <!-- <div class="col-md-3">
            <fg-input type="password" label="Old Password" placeholder="Old Password" v-model="user.oldPassword">
            </fg-input>
          </div> -->
          <div class="col-md-3">
            <fg-input type="password" label="New Password" placeholder="New Password" v-model="user.newPassword">
            </fg-input>
          </div>
          <div v-if="userInfo.role == 14" class="col-md-12">
            <label>Restaurant(s) You Have Access To</label></br>
            <input type="checkbox" for="select_all" v-model="selectAll">
            <label for="select_all">Select All</label>
          </div>
          <div v-if="userInfo.role == 14" class="col-md-12 restaurants_wrapper">
            <div v-if="userInfo.company != 'Support'" v-for="rest in restaurants" class="col-md-3">
              <input type="checkbox" v-bind:value="rest.externalId" v-bind:id="rest.externalId" v-model="myRestaurants">
              <label class="checkbox_label" v-bind:for="rest.externalId">{{rest.entityName}} - <span class="address_small">{{rest.entityAddress.address}}</span></label>
            </div>
          </div>
          <!-- <div class="col-md-3">
            <fg-input type="password" label="Confirm Password" placeholder="Confirm Password" v-model="user.confirmPassword">
            </fg-input>
          </div> -->
          <div class="col-md-3">
            <div class="form-group">
              <button type="submit" class="btn btn-primary btn-fill btn-wd" @click.prevent="updateProfile">
                Update Profile
              </button>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
import {API} from 'src/api'
import PortalNotification from 'src/components/UIComponents/NotificationPlugin/Notification.vue'
if(localStorage.userInfo) {
  var userInfo = JSON.parse(localStorage.userInfo)
}
  export default {
    data () {
      return {
        user: {
          company: '',
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          newPassword: ''
        },
        userInfo: userInfo,
        restaurants: [],
        myRestaurants: [],
      }
    },
    components: {
      PortalNotification
    },
    methods: {
      updateProfile () {
        var self = this
        API.put('/profile/' + encodeURIComponent(this.user.email), {
          fname: this.user.firstName,
          lname: this.user.lastName,
          email: this.user.email,
          phone: this.user.phone,
          password: this.user.newPassword,
          company: this.user.company,
          role: this.user.role,
          restaurants: this.myRestaurants,
          npuser: true
        })
        .then(function (response) {
          // console.log(JSON.stringify(response, null, '  '))
          delete localStorage.userInfo
          localStorage.userInfo = JSON.stringify(response.data)
          self.notifyVue('top', 'center', 'Your profile has been updated successfully!', 'ti-check-box', 'success')
        })
        .catch(function (error) {
          console.log(error)
          self.notifyVue('top', 'center', 'There was a problem when updating your profile', 'ti-alert', 'danger')
        })
      },
      getUser () {
        var self = this
        //API.get('/profile?npuser=true&company=' + userInfo.company + '&role=' + userInfo.role + '&uid=' + userInfo.uid)

        return API.get('/profile/' + encodeURIComponent(userInfo.email) + '?npuser=true')
        .then(function (response) {
          console.log('response', response)
          delete localStorage.userInfo
          localStorage.userInfo = JSON.stringify(response.data)
          if(response.data.extid) {
            self.myRestaurants = response.data.extid.split(',')
          }
        })
      },
      setUser () {
        this.user.company = userInfo.company
        this.user.firstName = userInfo.fname
        this.user.lastName = userInfo.lname
        this.user.phone = userInfo.phone
        this.user.email = userInfo.email
        if(userInfo.extid) {
          this.myRestaurants = userInfo.extid.split(',')
        }

      },
      getRestaurants () {
        var self = this
        return API.get('/restaurant/NP?np=' + encodeURIComponent(userInfo.company) + '&role=' + userInfo.role + '&uid=' + userInfo.uid + '&sortkey=Address&sortorder=asc')
        .then(function (response) {
          if (response.data.entities) {
            self.restaurants = Object.values(response.data.entities);
          }
          //console.log('restaurants', self.restaurants)
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      notifyVue (verticalAlign, horizontalAlign, message, icon, type) {
        this.$notifications.notify(
          {
            message: message,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
      }
    },
    computed: {
      selectAll: {
        get: function () {
          return this.restaurants ? this.myRestaurants.length == this.restaurants.length : false;
        },
        set: function (value) {
          var selected = [];
          if (value) {
            this.restaurants.forEach(function (rest) {
              selected.push(rest.externalId);
            });
          }
          this.myRestaurants = selected;
        }
      }
    },
    mounted() {
      this.getRestaurants()
      .then(() => {
        return this.getUser();
      })
      .then(() => {
        this.setUser();
      })
      .catch(error => {
        console.error('Error during initialization:', error);
      });
    }
  }

</script>
<style scoped>
.card .header {
  text-align: left !important;
}
.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// EditProfileForm.vue?0e4254be